import { elementController } from '@public-pages/runtime-core';
import { useSmartScript } from '@public-pages/smartscript';
import { handleCpfMask } from '@public-pages/utils';
import { getSessionIDAsync } from 'redline-client-sdk';

import { base64Encrypt } from '../../../utils/base64';

elementController('login-form', ({ query }) => {
  const { generateOneLinkURL } = useSmartScript({
    oneLinkURL: 'https://consumidorpositivo.onelink.me/gaEq',
  });
  const cpfForm = query('[data-submit-cpf]') as HTMLFormElement;
  const cpfField = query('[data-input-cpf]') as HTMLInputElement;

  const buttonLink = cpfForm.getAttribute('data-button-link')!;

  cpfForm.addEventListener('submit', async (event: SubmitEvent) => {
    event.preventDefault();

    const sanitazedDocument = sanitazeDocument(cpfField.value);
    const redirectUrl = await handleGenerateRedirectLink(sanitazedDocument);
    window.location.href = redirectUrl;
  });

  cpfField.addEventListener('keypress', handleCpfMask);

  function sanitazeDocument(rawDocument: string) {
    return String(rawDocument).replace(/[^0-9.-]+/gm, '');
  }

  async function handleGenerateRedirectLink(cpf: string) {
    const URL = buttonLink || 'https://app.consumidorpositivo.com.br';
    const cleanCpf = clean(cpf);
    const cpf64 = base64Encrypt(cleanCpf);

    const oneLinkURL = await generateOneLinkURL('', {
      af_web_dp: buttonLink,
      deep_link_value: JSON.stringify({ target_url: buttonLink }),
    });

    const sessionId = await getSessionIDAsync();

    if (oneLinkURL)
      return `${oneLinkURL}&session_id=${sessionId}&identify=${cpf64}`;

    const searchParams = window.location.search;

    const normalizeQuestionMarkFromMidia = searchParams.startsWith('?')
      ? searchParams.replace('?', '&')
      : searchParams;

    return `${URL}?identify=${cpf64}${normalizeQuestionMarkFromMidia}`;
  }

  function clean(doc: string) {
    return doc.replace('-', '').split('.').join('');
  }
});
